import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './CompanyNotFound.css';

function CompanyNotFound() {
  const { companyId } = useParams();
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/', { replace: true });
  };

  const handleViewExample = () => {
    navigate('/company/1', { replace: true });
    window.location.reload();
  };

  return (
    <div className="companyNotFoundContainer">
      <h1>Company Not Found</h1>
      <p>Company with ID "{companyId}" does not exist or has been removed.</p>
      <div className="actionButtons">
        <button onClick={handleReturnHome} className="homeLink">
          Return to Home
        </button>
        <button onClick={handleViewExample} className="viewExampleLink">
          View Example Company
        </button>
      </div>
    </div>
  );
}

export default CompanyNotFound; 